import BasicRouterView from "../../components/BasicRouterView.vue";

const assistenteIARoutes = {
  path: "assistente-ia",
  redirect: { name: "fale-com-a-ia" },
  meta: {
    label: "Assistente IA",
    icon: "smart_toy",
    show: true,
    tabsShow: false,
    permissioOnly: false,
  },
  component: BasicRouterView,
  children: [
    {
      path: "fale-com-a-ia",
      name: "fale-com-a-ia",
      meta: {
        label: "Fale com a IA",
        icon: "smart_toy",
        show: true,
        breadcrumb: true,
        permissioOnly: false,
      },
      component: () =>
        import(/* webpackChunkName: "assistente-ia" */ "./views/FaleComIA.vue"),
    },
  ],
};

export default assistenteIARoutes;
